module.exports = __webpack_public_path__ + "img/onboarded.4e6845b2.png";